import { useCurrentWorkspace } from "@accurx/auth";
import { Text } from "@accurx/design";

import { ROUTES } from "shared/Routes";

import { BreadcrumbWrapper } from "./BreadcrumbWrapper";
import { RouterLink } from "./RouterLink";

export type BreadcrumbProps = {
    title?: string;
    wrapper?: boolean;
};

export const Breadcrumb = ({ title, wrapper = true }: BreadcrumbProps) => {
    const { organisationName } = useCurrentWorkspace();

    return (
        <BreadcrumbWrapper wrapperContent={wrapper}>
            <RouterLink to={ROUTES.home}>{organisationName}</RouterLink>
            <Text as="span" props={{ className: "mx-2" }} skinny>
                /
            </Text>
            <Text as="span" skinny>
                {title}
            </Text>
        </BreadcrumbWrapper>
    );
};
